import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Form,
  Col,
  Modal,
  Popover,
  message,
  Row,
  Select,
  Input,
  Checkbox,
} from "antd";
import { userSignOut } from "../../appRedux/actions/Auth";
import ProfileImage from "../../assets/images/default_profile.jpg";
import Econnect from "../../assets/images/AppLogo/Econnect.svg";
import Estimation from "../../assets/images/AppLogo/Estimation_tool.svg";
import Ecrm from "../../assets/images/AppLogo/Ecrm.svg";
import Email_Tool from "../../assets/images/AppLogo/Email_Tool.svg";
import ETask_Hub from "../../assets/images/AppLogo/ETask_Hub.svg";
import Frame from "../../assets/images/AppLogo/Frame.svg";
import QwilrProposal from "../../assets/images/AppLogo/Proposal.png";
import { withRouter } from "react-router-dom";
import Service from "../../service";
// Punch In/Out button is disabled for TimeChamp-tracked staff (the API is the
// single source of attendance in/out) but INTERNS are outside that model — they
// are not tracked by TimeChamp, so they keep the manual punch flow.
import PunchButton from "../../components/PunchButton/PunchButton";



import { showAuthLoader, hideAuthLoader } from "../../appRedux/actions/Auth";
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  TAB_SIZE,
} from "../../constants/ThemeSetting";

import { capitalizeFirstLetter, relationshipArry } from "../../components/EmpInfoManagement/constants";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

import Trophylsner from '../../assets/KarmaIcons/waffle.png';
import { getResource } from "../../util/getResourcePermission";
import config from "../../permission/config.json"
import { getRoles } from "../../util/getRoles";

const formItemLayoutContact = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const popoverStyle = {
  position: "absolute",
  top: "50px",
  right: "0",
  width: "250px",
  background: "white",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  borderRadius: "8px",
  padding: "16px",
  border: "1px solid #ddd",
};

const profileContainerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const gridContainerStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: "10px",
  border: "1.427px solid #07385C",
  padding: "8px",
  background: "linear-gradient(180deg, #FFF 0%, #DAF0FF 100%)",
  borderRadius: " 14.265px",
};

const buttonStyle = {
  padding: "10px",
  borderRadius: "6px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  border: "none",
  cursor: "pointer",
  background: "transparent"
};

const buttonTextStyle = {
  fontSize: "12px",
  marginTop: "5px",
  color: "gray"
}
const exceptThisSymbols = ["e", "E", "+", "-", "."];
const notificationProductAccessMap = [
  { key: "hrms", accessKey: "isHRMS", label: "HRMS" },
  { key: "pms", accessKey: "pms_applicable", label: "TaskHub" },
  { key: "ecrm", accessKey: "isECRM", label: "CRM" },
];
const hasProductAccess = (value) =>
  value === true || value === "true" || value === 1 || value === "1";
const UserProfile = (props) => {
  const dispatch = useDispatch();
  const LogoAction = useSelector((state) => state.common);
  const Logo = localStorage.getItem('LogoURL');
  const [isOpen, setIsOpen] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setdata] = useState([]);
  const [dataCount, setCountdata] = useState([]);
  const [visible, setVisible] = useState(false);
  const [addeditform] = Form.useForm();
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);
  const [flag, setflag] = useState(false);
  const { authUser } = useSelector(({ auth }) => auth);
  const user_data = JSON.parse(localStorage.getItem('user_data'));
  const [ModalDestry, setModalDestry] = useState(false)
  const location = useLocation()
  const { width, themeType } = useSelector(({ settings }) => settings);

  const [sideBarlogo, setSideBarlogo] = useState();

  const [ssoToken, setssoToken] = useState(localStorage.getItem("ssoToken"))

  const allowedCodes = ["ETAMD577", "ETAMD335", "ETAMD5", "ETAMD334", "ETAMD335", "ETAMD262", "ETAMD733", "ETAMD719", "ETAMD753", "ETAMD754"]
  // const apiUrl = import.meta.env.REACT_TASKHUB_REDIRECT;
  const handleVisibleChange = (visible) => {
    setVisible(visible);
    // readNotificationFromUser();
  };
  const [checked, setChecked] = useState({
    "isHRMS": false,
    "isTaskHub": false,
    "isEConnect": false,
    "isECRM": false,
    "isEmailTool": false,
    "isEstimationTool": false,
    "isProposal": false,
    "isVMS": false,
  })

  const handleModuleGetData = async (id) => {
    try {
      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.empGteApplicable + "/" + id,
      });
      if (response.data.status === 200) {
        console.log(response, 'handleModuleGetData');
        let userData = response.data.data;

        // Create checked state with only the permission fields
        const permissionData = {
          isHRMS: userData.isHRMS || false,
          isTaskHub: userData.isTaskHub || false,
          isEConnect: userData.isEConnect || false,
          isECRM: userData.isECRM || false,
          isEmailTool: userData.isEmailTool || false,
          isEstimationTool: userData.isEstimationTool || false,
          isProposal: userData.isProposal || false,
          isVMS: userData.isVMS || false,
        };

        setChecked(permissionData);
        // setdefaultValues(permissionData);
        // setPreSelectedValues(permissionData);
      }
      dispatch(hideAuthLoader());
    } catch (error) {
      console.log(error);
    }
  };



  useEffect(() => {

    handleModuleGetData(authUser._id)
  }, [authUser._id])

  const isPermissionChange = async (id) => {
    try {
      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.isPermissionChange + "/" + id,
      });

      if (response.data.status === 200) {
        dispatch(userSignOut());
      }
    } catch (error) {
      console.log(error)
    }
  }

  console.log(checked, 'checked');

  useEffect(() => {
    // getNotification();
    setInterval(() => {
      // getNotification();
    }, 300000);
  }, []);

  // useEffect(() => {
  //   // console.log(authUser.isPasswordChanged,'chchchchchch')
  //   if (authUser.isPasswordChanged == false) {
  //     // console.log(authUser.isPasswordChanged,'chchchchchch...')

  //     success()
  //   }
  //   if (authUser?.isContactsAdded == false) {

  //     contact()
  //   }


  // }, [authUser.isPasswordChanged])

  // useEffect(()=>{
  //   if ((authUser?.isEducationDetailsAdded == false
  //     ||authUser?.isExperienceDetailsAdded
  //     ==false)&& location.pathname!=='/my-profile') {
  // // console.log( location.pathname,' location.pathname');

  //       EducationAndExperience()
  //       Modal.destroyAll()
  //   }
  // },[location.pathname])


  // Watch for changes in `authUser` instead of just `authUser.isPasswordChanged`

  // useEffect(() => {
  //     if (
  //         (authUser?.isEducationDetailsAdded === false || authUser?.isExperienceDetailsAdded === false) &&
  //         location.pathname !== '/my-profile'
  //     ) {
  //       return  EducationAndExperience();
  //         Modal.destroyAll();
  //     }
  // }, [authUser?.isEducationDetailsAdded === false || authUser?.isExperienceDetailsAdded === false , location.pathname]); // Added `authUser` to dependencies

  const contentOfPopover = (<div className="absolute top-12 right-0 w-56 bg-white shadow-lg rounded-lg p-4 border">
    <div className="flex flex-col items-center">
      <img
        src="https://via.placeholder.com/50" // Replace with actual profile image
        alt="Profile"
        className="w-12 h-12 rounded-full"
      />
      <span className="font-medium mt-2">Harshal</span>
    </div>

    {/* Action Buttons */}
    <div className="grid grid-cols-3 gap-2 mt-3">
      <button className="p-2 bg-gray-100 rounded flex flex-col items-center">
        <span className="text-sm">Task Hub</span>
      </button>
      <button className="p-2 bg-gray-100 rounded flex flex-col items-center">
        <span className="text-sm">HRMS</span>
      </button>
      <button className="p-2 bg-gray-100 rounded flex flex-col items-center">
        <span className="text-sm">E-Connect</span>
      </button>
      <button className="p-2 bg-gray-100 rounded flex flex-col items-center">
        <span className="text-sm">E-CRM</span>
      </button>
      <button className="p-2 bg-gray-100 rounded flex flex-col items-center">
        <span className="text-sm">Email Tool</span>
      </button>
      <button className="p-2 bg-gray-100 rounded flex flex-col items-center">
        <span className="text-sm">Estimation</span>
      </button>
    </div>
  </div>)
  const getAdminListLogo = async () => {
    try {
      const params = `/${authUser?._id}`;
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.adminSetting + params,
      });
      if (response.data?.data?.config?.adminSetting?.logo) {
        setSideBarlogo(response.data.data.config.adminSetting.logo)
      } else {
        if (LogoAction.logo) {
          setSideBarlogo(LogoAction.logo)
        } else if (Logo) {
          setSideBarlogo(Logo)
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getNotification = async () => {
    setTimeout(() => {
      setflag(false);
    }, 2000);
    try {
      const reqBody = {
        id: authUser?._id,
        department_name: authUser?.department_id?.department_name,
      };
      // dispatch(showAuthLoader());

      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.getNotification,
        body: reqBody,
      });
      if (response.data.status === 200) {
        setdata(response?.data?.data);
        setCountdata(response?.data.metaData.totalCount);
        // message.success(response.metaData.totalCount);
        // console.log(response.data.metaData.totalCount )
      }
      // dispatch(hideAuthLoader());
    } catch (error) {
      // dispatch(hideAuthLoader());
      console.log(error);
    }
  };

  let ids = [
    data?.map((item) => {
      return item?._id;
    }),
  ];
  const readNotificationFromUser = async () => {
    try {
      const reqBody = {
        notification_id: authUser?._id,
        allnotification_id: ids,
      };
      // dispatch(showAuthLoader());

      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.readNotificationFromUser,
        body: reqBody,
      });
      if (response.data.status === 200) {
        // getNotification();
        // message.success(response.metaData.totalCount);
        // console.log(response.data.metaData.totalCount )
      }
      // dispatch(hideAuthLoader());
    } catch (error) {
      // dispatch(hideAuthLoader());
      console.log(error);
    }
  };


  // fetch contact data from api
  const fetchContactDetails = async () => {
    try {
      const empId = authUser?._id;
      const reqBody = {
        employee_id: empId,

      };
      // if (searchText && searchText !== "") {
      //   setSearchEnabled(true);
      // }
      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.contactList,
        body: reqBody,
      });


      dispatch(hideAuthLoader());
    } catch (error) {
      console.log(error);
      dispatch(hideAuthLoader());
    }
  };

  const handleAddEdit = async (values) => {
    try {
      const empId = authUser?._id;
      const reqBody = {
        employee_id: empId,
        employee_contact: {
          ...values,
        },
      };

      dispatch(showAuthLoader());
      let data = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.addContact,
        body: reqBody,
      });

      fetchContactDetails();
      getUserDetailsByID();
      let isContactsAdded = user_data?.isContactsAdded;//localStorage.getItem("isContactsAdded")
      console.log(isContactsAdded, "isContactsAdded", data);
      if (data.status == 400) {
        message.error(data.data.message)
      } else {
        if (!isContactsAdded) {
          Modal.destroyAll();
          addeditform.resetFields()
        }
      }

      dispatch(hideAuthLoader());
    } catch (error) {
      console.log(error);
      dispatch(hideAuthLoader());
    }
    // handleCloseEditModal();
  };
  const readNotification = async (notification_id, slug) => {
    try {
      if (props.location.pathname == slug) {
        window.location.href = slug;
      }
      setVisible(false);
      const reqBody = {
        notification_id: notification_id,
        user_id: authUser?._id,
      };
      //   dispatch(showAuthLoader());

      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.readNotification,
        body: reqBody,
      });
      if (response.data.status === 200) {
        // setdata(response?.data?.data);
        // setCountdata(response?.data.metaData.totalCount);
        // message.success(response.metaData.totalCount);
        // console.log(response.data.metaData.totalCount )
      }
      //   dispatch(hideAuthLoader());
    } catch (error) {
      // dispatch(hideAuthLoader());
      console.log(error);
    }
  };
  const getUserDetailsByID = async () => {
    try {
      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.empById + "/" + authUser?._id,
        body: {},
      });

      const userData = response.data.data;
      localStorage.setItem("user_data", JSON.stringify(userData));
      dispatch(hideAuthLoader());
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  }


  const changepassword = async (value) => {
    try {
      dispatch(showAuthLoader());
      const reqBody = {
        oldpassword: value?.current_password,
        newPassword: value?.confirm_password,
        emp_id: authUser?._id,
        isPasswordChanged: true,
      };
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.hrmschangepassword,
        body: reqBody,
      });
      if (response.data.status === 200) {
        message.success(response.data.message);
        setIsModalOpen(false);
        // Password changed — the server has invalidated existing tokens, so force
        // re-login (here and, via the security stamp, on every other product).
        setTimeout(() => {
          localStorage.clear();
          window.location.href = "/signin";
        }, 1200);
      } else {
        message.error(response.data.message);
      }
      dispatch(hideAuthLoader());
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };

  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };
  useEffect(() => {
    getAdminListLogo();
  }, [LogoAction.logo])

  useEffect(() => {
    if (authUser?.isPasswordChanged === false) {
      success();
    }
    if (authUser?.isContactsAdded === false) {
      contact();
    }
    if (

      authUser.isEducationDetailsAdded == false &&
      location.pathname !== "/my-profile"
    ) {
      EducationAndExperience();

    }
    if ((authUser.experience != 0 && authUser.isExperienceDetailsAdded == false) &&
      location.pathname !== "/my-profile"
    ) {
      EducationAndExperience();

    }
    // console.log(authUser,'authUser');

    if (authUser.isPermissionChange) {
      const data = isPermissionChange(authUser._id)
    }


  }, [authUser]);  // 🔥 Ensure re-run when authUser or pathname changes

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 10 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 },
    },
  };

  const [openPopover, setOpenPopover] = useState(false);
  // General Settings (admin only) — TimeChamp API token
  const [isGeneralSettingsOpen, setIsGeneralSettingsOpen] = useState(false);
  const [isTokenSaving, setIsTokenSaving] = useState(false);
  const [tokenInfo, setTokenInfo] = useState(null);
  const [tokenForm] = Form.useForm();
  const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
  const [isNotificationSaving, setIsNotificationSaving] = useState(false);
  const [notificationProducts, setNotificationProducts] = useState([]);
  const [selectedProductKeys, setSelectedProductKeys] = useState([]);

  // const { authUser } = useSelector(({ auth }) => auth);  
  const first_name =
    authUser.first_name.charAt(0).toUpperCase() + authUser.first_name.slice(1);
  const last_name =
    authUser.last_name.charAt(0).toUpperCase() + authUser.last_name.slice(1);

  const userName = first_name + " " + last_name;

  const getFallbackNotificationProducts = () => {
    return notificationProductAccessMap
      .filter((product) => hasProductAccess(authUser?.[product.accessKey]))
      .map((product) => ({
        product_key: product.key,
        product_label: product.label,
        econnect_enabled: true,
        email_enabled: authUser?.email_notifications_enabled !== false,
      }));
  };

  const openNotificationSettingsModal = async () => {
    try {
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.getNotificationSettings,
      });
      if (response?.data?.status === 200 && response?.data?.data) {
        const products = response?.data?.data?.products || [];
        const selectedProducts = response?.data?.data?.selected_products || [];
        if (products.length) {
          setNotificationProducts(products);
          setSelectedProductKeys(selectedProducts);
        } else {
          const fallbackProducts = getFallbackNotificationProducts();
          setNotificationProducts(fallbackProducts);
          setSelectedProductKeys(
            fallbackProducts
              .filter((product) => product.email_enabled)
              .map((product) => product.product_key)
          );
        }
      } else {
        const fallbackProducts = getFallbackNotificationProducts();
        setNotificationProducts(fallbackProducts);
        setSelectedProductKeys(
          fallbackProducts
            .filter((product) => product.email_enabled)
            .map((product) => product.product_key)
        );
      }
      setIsNotificationModalOpen(true);
      setOpenPopover(false);
    } catch (error) {
      console.log(error);
      message.error("Unable to load notification settings");
    }
  };

  const updateEmailNotificationSetting = async () => {
    try {
      setIsNotificationSaving(true);
      const response = await Service.makeAPICall({
        methodName: Service.putMethod,
        api_url: Service.updateNotificationSettings,
        body: {
          selected_products: selectedProductKeys,
        },
      });
      if (response?.data?.status === 200 && response?.data?.data) {
        const products = response?.data?.data?.products || [];
        const selectedProducts = response?.data?.data?.selected_products || [];
        setNotificationProducts(products);
        setSelectedProductKeys(selectedProducts);
        message.success("Notification settings updated");
      } else {
        message.error(response?.data?.message || "Unable to update settings");
      }
    } catch (error) {
      console.log(error);
      message.error("Unable to update settings");
    } finally {
      setIsNotificationSaving(false);
    }
  };

  // Only the admin role may manage integration credentials. Resolved by role
  // NAME via getRoles/roles.json rather than a hardcoded ObjectId. The server
  // enforces the same list — this just keeps the menu clean.
  const isAdminRole = getRoles([config.ROLES.ADMIN]);

  const openGeneralSettingsModal = async () => {
    try {
      setOpenPopover(false);
      setIsGeneralSettingsOpen(true);
      tokenForm.resetFields();
      const response = await Service.makeAPICall({
        methodName: Service.getMethod,
        api_url: Service.getTimeChampToken,
      });
      if (response?.data?.status === 200) {
        setTokenInfo(response.data.data);
      } else {
        setTokenInfo(null);
        message.error(response?.data?.message || "Unable to load settings");
      }
    } catch (error) {
      console.log(error);
      setTokenInfo(null);
      message.error("Unable to load settings");
    }
  };

  const saveTimeChampToken = async (values) => {
    try {
      setIsTokenSaving(true);
      const response = await Service.makeAPICall({
        methodName: Service.putMethod,
        api_url: Service.updateTimeChampToken,
        body: { token: values.token },
      });
      if (response?.data?.status === 200) {
        message.success(response.data.message || "Token updated");
        tokenForm.resetFields();
        // Re-read so the masked value and status reflect what was just saved.
        const refreshed = await Service.makeAPICall({
          methodName: Service.getMethod,
          api_url: Service.getTimeChampToken,
        });
        if (refreshed?.data?.status === 200) setTokenInfo(refreshed.data.data);
      } else {
        message.error(response?.data?.message || "Unable to update token");
      }
    } catch (error) {
      console.log(error);
      message.error("Unable to update token");
    } finally {
      setIsTokenSaving(false);
    }
  };

  const tokenStatusStyle = {
    valid: { color: "#237804", background: "#f6ffed", border: "1px solid #b7eb8f" },
    expired: { color: "#ad6800", background: "#fffbe6", border: "1px solid #ffe58f" },
    invalid: { color: "#a8071a", background: "#fff1f0", border: "1px solid #ffa39e" },
    missing: { color: "#595959", background: "#fafafa", border: "1px solid #d9d9d9" },
  };

  const userMenuOptions = (
    <ul className="gx-user-popover">
      {authUser?.emp_code && (
        <>
          {" "}
          <li
            onClick={() => {
              setOpenPopover(false)
              props.history.push("/my-profile");
            }}
          >
            Edit Profile
          </li>
          <li onClick={() => {
            props.history.push('/employee-overview')
          }}>Employee Overview</li>
          <li onClick={showModal}>Change Password</li>
          <li onClick={openNotificationSettingsModal}>Notification Settings</li>
          {isAdminRole && (
            <li onClick={openGeneralSettingsModal}>General Settings</li>
          )}
          <li onClick={() => dispatch(userSignOut())}>Logout</li>
        </>
      )}
      {!authUser?.emp_code && (
        <>
          {" "}
          <li onClick={() => props.history.push("/admin-edit")}>
            Edit Profile
          </li>
          <li onClick={openNotificationSettingsModal}>Notification Settings</li>
          {isAdminRole && (
            <li onClick={openGeneralSettingsModal}>General Settings</li>
          )}
          <li onClick={() => dispatch(userSignOut())}>Logout</li>
        </>
      )}
    </ul>
  );

  const changepasswordForCommon = async (value) => {

    // console.log(value,'valuevalue',isPasswordData);

    try {
      dispatch(showAuthLoader());
      const reqBody = {
        oldpassword: value.old_password,
        newPassword: value.new_password,
        emp_id: authUser?._id,
        isPasswordChanged: true
      };
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.hrmschangepassword,
        body: reqBody,
      });
      if (response.data.status == 200) {
        message.success(response.data.message);
        // setIsModalOpen(false);
        // dispatch(setIsPasswordChange(false))

        Modal.destroyAll();
        // Password changed — force re-login (server invalidated existing tokens).
        setTimeout(() => {
          localStorage.clear();
          window.location.href = "/signin";
        }, 1200);
      } else {
        message.error(response.data.message);
      }
      dispatch(hideAuthLoader());
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };



  const success = () => {
    Modal.warning({
      title: 'Change Password',
      content: (
        <>
          <div className="CVhangePassword">
            <Form
              onFinish={changepasswordForCommon}
              {...formItemLayout}
            >
              <Form.Item
                label="Current Password"
                name="old_password"
                className="search-row"
                rules={[
                  {
                    required: true,
                    message: "Please enter Current Password!",
                  },
                ]}
              >
                <Input.Password name="old_password" />
              </Form.Item>
              <Form.Item
                label="New Password"
                name="new_password"
                className="search-row"
                rules={[
                  {
                    required: true,
                    message: "Please enter New Password!",
                  },
                ]}
              >
                <Input.Password name="new_password" />
              </Form.Item>
              <Form.Item
                label="Confirm Password"
                name="confirm_password"
                className="search-row"
                rules={[
                  {
                    required: true,
                    message: "Please enter Confirm Password!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("new_password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        "The confirm passwords that you entered do not match!"
                      );
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>
              <div className="profilecenter-uploadbtn">
                <Button type="primary" htmlType="submit">
                  Change Password
                </Button>
              </div>
            </Form>
          </div>

        </>
      ),
      footer: false,
      style: { textAlign: 'center' },
    });
  };

  const contact = () => {
    Modal.warning({
      title: "Add Contact",
      content: (
        <>
          <div className="basic_info_form_wrapper">
            <Form {...formItemLayoutContact} form={addeditform} onFinish={handleAddEdit}>
              <Row>
                <Col md={24} sm={24}>
                  <Form.Item
                    name="name"
                    label="Name"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Name",
                      },
                      {
                        max: 30,
                        message: "Name should be less than 30 characters",
                      },
                    ]}
                    normalize={capitalizeFirstLetter}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col md={24} sm={24}>
                  <Form.Item
                    name="mobile"
                    label="Contact No."
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Contact Number",
                      },
                      {
                        len: 10,
                        message: "Please enter valid Contact Number",
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      onKeyDown={(e) =>
                        exceptThisSymbols.includes(e.key) && e.preventDefault()
                      }
                      onChange={(e) => {
                        const { value } = e.target;
                        addeditform.setFieldsValue({ mobile: value });
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col md={24} sm={24}>
                  <Form.Item
                    name="relationship"
                    label="Relationship"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Relationship",
                      },
                      {
                        max: 30,
                        message: "Relationship should be less than 30 characters",
                      },
                    ]}
                  >
                    <Select placeholder="Select Relationship">
                      {relationshipArry?.map((i) => (
                        <Select.Option key={i} value={i}>
                          {i}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col md={24} sm={24}>
                  <Form.Item
                    {...formItemLayout}
                    className="ant-col-xs-24 ant-col-sm-24 leavebtns"
                  >
                    <div className="add-leave-button">
                      <Button type="primary" htmlType="submit" id="addbutton">
                        Submit
                      </Button>
                    </div>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </>
      ),
      footer: false,
      style: { textAlign: "center" },

    });

  }

  const EducationAndExperience = () => {
    Modal.warning({
      title: "Add Details",
      content: (
        <>
          <div className="basic_info_form_wrapper">
            <p>Please Fill Your Pending Details
            </p>
            {/* <Link to='/my-profile'> */}
            <Button
              className="btn-success"
              onClick={() => {
                props.history.push('/my-profile')
                Modal.destroyAll()
              }}
            >
              Click
            </Button>
            {/* </Link> */}

            {/* <a href={'}>
                              <Button
                                className="btn-success"
                               
                              >
                               Click 
                              </Button>
                            </a> */}
          </div>
        </>
      ),
      footer: false,
      style: { textAlign: "center" },

    });

  }

  let navStyle = useSelector(({ settings }) => settings.navStyle);
  if (width < TAB_SIZE && navStyle === NAV_STYLE_FIXED) {
    navStyle = NAV_STYLE_DRAWER;
  }
  // console.log(`https://taskhub.elsner.com/signin?token=${ssoToken}`,'SSoToknT');

  return (
    <div className="gx-flex-row gx-align-items-center gx-avatar-row">


      {/* {allowedCodes?.includes(user_data?.emp_code) &&} */}
      {/* Interns only: TimeChamp does not track them, so they punch manually.
          Everyone else's in/out comes from the TimeChamp sync. */}
      {getRoles([config.ROLES.INTERN]) && <PunchButton />}
      <div className="header-menu">
        {checked?.isTaskHub || checked?.isECRM || checked?.isEConnect || checked?.isEmailTool ||
          checked?.isEstimationTool || checked?.isProposal || checked?.isVMS ?

          <Popover placement="bottomRight" trigger='click'
            content={
              <div style={gridContainerStyle}>

                {checked?.isTaskHub &&
                  <a href={`${process.env.REACT_APP_TASKHUB_SIGNIN}?token=${ssoToken}`}
                    target="_blank" style={buttonTextStyle}>
                    <button style={buttonStyle}>
                      <img src={ETask_Hub} alt="Task Hub" style={{ width: "30px", height: "30px" }} />
                      <span style={buttonTextStyle}>Task Hub</span>
                    </button>
                  </a>
                }
                {checked?.isEConnect &&
                  <a href={`${process.env.REACT_APP_ECONNECT_SIGNIN}?token=${ssoToken}`}
                    target="_blank" style={buttonTextStyle}>
                    <button style={buttonStyle}>

                      <img src={Econnect} alt="E-Connect" style={{ width: "30px", height: "30px" }} />
                      <span style={buttonTextStyle}>E-Connect</span>
                    </button>
                  </a>}
                {/* <button style={buttonStyle}>
                <img src="https://via.placeholder.com/30" alt="HRMS" />
                <span style={buttonTextStyle}>HRMS</span>
              </button> */}
                {checked?.isECRM &&
                  <a href={`${process.env.REACT_APP_CRM_LOGIN}?token=${ssoToken}`}
                    target="_blank" style={buttonTextStyle}>
                    <button style={buttonStyle}>
                      <img src={Ecrm} alt="E-CRM" style={{ width: "30px", height: "30px" }} />
                      <span style={buttonTextStyle}>E-CRM</span>
                    </button></a>}



                {checked?.isEmailTool &&
                  // <a href={`https://tool.elsnerdev.com/latest/customer/index.php/guest/returnsso-login?token=${ssoToken}`} target="_blank" style={buttonTextStyle}>
                  <a href={`${process.env.REACT_APP_EMAIL_TOOL_LOGIN}?token=${ssoToken}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={buttonTextStyle}>
                    <button style={buttonStyle}>
                      <img src={Email_Tool} alt="Email Tool" style={{ width: "30px", height: "30px" }} />
                      <span style={buttonTextStyle}>Email Tool</span>
                    </button>
                  </a>}
                {checked?.isEstimationTool &&
                  <a href={`${process.env.REACT_APP_ESTIMATION_TOOL_LOGIN}?token=${ssoToken}`} target="_blank" style={buttonTextStyle}>   <button style={buttonStyle}>
                    <img src={Estimation} alt="Estimation" style={{ width: "30px", height: "30px" }} />
                    <span style={buttonTextStyle}>Estimation</span>
                  </button></a>}

                {checked?.isProposal && process.env.REACT_APP_PROPOSAL_SIGNIN &&
                  <a href={`${process.env.REACT_APP_PROPOSAL_SIGNIN}?token=${ssoToken}`} target="_blank" style={buttonTextStyle}>
                    <button style={buttonStyle}>
                      <img src={QwilrProposal} alt="Proposal" style={{ width: "30px", height: "30px" }} />
                      <span style={buttonTextStyle}>Proposal</span>
                    </button>
                  </a>}

                {checked?.isVMS && process.env.REACT_APP_VMS_SIGNIN &&
                  <a href={`${process.env.REACT_APP_VMS_SIGNIN}?token=${ssoToken}`}
                    target="_blank" rel="noopener noreferrer" style={buttonTextStyle}>
                    <button style={buttonStyle}>
                      <span style={{ width: "30px", height: "30px", display: "flex", alignItems: "center", justifyContent: "center", background: "#03497A", color: "#fff", borderRadius: "8px", fontSize: "10px", fontWeight: 700 }}>VMS</span>
                      <span style={buttonTextStyle}>VMS</span>
                    </button>
                  </a>}

                {checked?.isNoteTaker && process.env.REACT_APP_NOTETAKER_SIGNIN &&
                  <a href={`${process.env.REACT_APP_NOTETAKER_SIGNIN}?token=${ssoToken}`}
                    target="_blank" rel="noopener noreferrer" style={buttonTextStyle}>
                    <button style={buttonStyle}>
                      <span style={{ width: "30px", height: "30px", display: "flex", alignItems: "center", justifyContent: "center", background: "#03497A", color: "#fff", borderRadius: "8px", fontSize: "9px", fontWeight: 700 }}>NT</span>
                      <span style={buttonTextStyle}>NoteTaker</span>
                    </button>
                  </a>}

              </div>
            }>
            <div className="grid-icon">

              <img
                src={Frame}
                className="avatar-user"
                alt="User"
                style={{ cursor: 'pointer' }}
              />
            </div>

          </Popover> : ''
        }
      </div>
      {getResource(config.RESOURCES.WAFFLE, ["read"]) && (
        <><span className="waffle-icon" onClick={() => { props.history.push("/Waffle"); }} style={{ cursor: 'pointer' }}>
          <img src={Trophylsner} />

          <span className="waffle-count">
            {authUser?.total_remaining_karma ? authUser?.total_remaining_karma : 0} Waffle</span>
        </span>
        </>)}








      <Popover className="user-name-popover"
        placement="bottomRight"
        content={userMenuOptions}
        trigger="click"
        onOpenChange={(newVisible) => setOpenPopover(newVisible)}
      >
        <img
          src={
            authUser.emp_img
              ? `${Service.Server_Base_URL}/uploads/emp_images/${authUser.emp_img}`
              : ProfileImage
          }
          className="avatar-user"
          alt="User"
        />
        <span className="gx-avatar-name">
          {userName}
          <i className="icon icon-chevron-down gx-ml-2" />
        </span>
      </Popover>

      <Modal
        title="Notification Settings"
        visible={isNotificationModalOpen}
        onCancel={() => setIsNotificationModalOpen(false)}
        width={620}
        footer={[
          <Button key="cancel" onClick={() => setIsNotificationModalOpen(false)}>
            Cancel
          </Button>,
          <Button
            key="save"
            type="primary"
            loading={isNotificationSaving}
            onClick={updateEmailNotificationSetting}
          >
            Save Preferences
          </Button>,
        ]}
      >
        <div style={{ marginBottom: 12, color: "#6c757d" }}>
          Configure notifications only for accessible products.
        </div>

        <div style={{ marginBottom: 12, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ fontWeight: 600 }}>Notification Products</span>
          <Button
            size="small"
            onClick={() => {
              if (selectedProductKeys.length === notificationProducts.length) {
                setSelectedProductKeys([]);
                return;
              }
              setSelectedProductKeys(notificationProducts.map((product) => product.product_key));
            }}
          >
            {selectedProductKeys.length === notificationProducts.length ? "Clear All" : "Select All"}
          </Button>
        </div>
        <div
          style={{
            marginBottom: 10,
            border: "1px solid #e9ecef",
            borderRadius: 10,
            padding: "10px 14px",
            display: "grid",
            gridTemplateColumns: "1.5fr 0.7fr 0.8fr",
            gap: 12,
            fontWeight: 600,
            color: "#495057",
          }}
        >
          <span>Name</span>
          <span>Email</span>
          <span>eConnect</span>
        </div>

        {notificationProducts.map((product) => (
          <div
            key={product.product_key}
            className="notification-setting-row"
            style={{
              marginBottom: 10,
              border: "1px solid #e9ecef",
              borderRadius: 10,
              padding: "12px 14px",
              display: "grid",
              gridTemplateColumns: "1.5fr 0.7fr 0.8fr",
              alignItems: "center",
              gap: 12,
            }}
          >
            <span style={{ fontWeight: 600 }}>{product.product_label}</span>
            <Checkbox
              checked={selectedProductKeys.includes(product.product_key)}
              onChange={(event) => {
                const checkedValue = event.target.checked;
                setSelectedProductKeys((prev) => {
                  if (checkedValue) {
                    return [...new Set([...prev, product.product_key])];
                  }
                  return prev.filter((productKey) => productKey !== product.product_key);
                });
              }}
            >
            </Checkbox>
            <Checkbox checked disabled>
            </Checkbox>
          </div>
        ))}

        {!notificationProducts.length && (
          <div style={{ color: "#6c757d", textAlign: "center", padding: "24px 0" }}>
            No product access found for notification settings.
          </div>
        )}
      </Modal>
      <Modal
        title="General Settings"
        visible={isGeneralSettingsOpen}
        onCancel={() => setIsGeneralSettingsOpen(false)}
        width={620}
        footer={false}
      >
        <div style={{ fontWeight: 600, marginBottom: 4 }}>TimeChamp API Token</div>
        <div style={{ color: "#6c757d", marginBottom: 16 }}>
          Used to pull daily productive hours. Attendance depends on this — if the
          token stops working, days sync with no productive time.
        </div>

        <div
          style={{
            border: "1px solid #e9ecef",
            borderRadius: 10,
            padding: "12px 14px",
            marginBottom: 16,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
            <span style={{ fontWeight: 600 }}>Status</span>
            <span
              style={{
                padding: "1px 10px",
                borderRadius: 10,
                fontSize: 12,
                textTransform: "capitalize",
                ...(tokenStatusStyle[tokenInfo?.token_status] ||
                  tokenStatusStyle.missing),
              }}
            >
              {tokenInfo?.token_status || "unknown"}
            </span>
          </div>
          <div style={{ color: "#495057" }}>
            Current token: <b>{tokenInfo?.masked_token || "not set"}</b>
          </div>
          {tokenInfo?.using_env_fallback && (
            <div style={{ color: "#ad6800", marginTop: 6 }}>
              No token saved here yet — the one from the server .env is in use.
            </div>
          )}
          {tokenInfo?.expires_at && (
            <div style={{ color: "#495057", marginTop: 6 }}>
              Expires: {new Date(tokenInfo.expires_at).toLocaleString()}
            </div>
          )}
          {tokenInfo?.updated_At && (
            <div style={{ color: "#6c757d", marginTop: 6 }}>
              Last updated {new Date(tokenInfo.updated_At).toLocaleString()}
              {tokenInfo?.updated_by ? ` by ${tokenInfo.updated_by}` : ""}
            </div>
          )}
          {tokenInfo?.last_error && (
            <div style={{ color: "#a8071a", marginTop: 6 }}>
              Last error: {tokenInfo.last_error}
            </div>
          )}
        </div>

        <Form form={tokenForm} layout="vertical" onFinish={saveTimeChampToken}>
          <Form.Item
            label="New Token"
            name="token"
            rules={[{ required: true, message: "Please paste the TimeChamp token" }]}
          >
            <Input.TextArea rows={4} placeholder="Paste the TimeChamp API token" />
          </Form.Item>
          <div style={{ color: "#6c757d", marginBottom: 12 }}>
            The token is verified against TimeChamp before it is saved, so an
            expired one cannot be stored by mistake.
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button onClick={() => setIsGeneralSettingsOpen(false)}>Cancel</Button>
            <Button type="primary" htmlType="submit" loading={isTokenSaving}>
              Verify &amp; Save
            </Button>
          </div>
        </Form>
      </Modal>
      <Modal
        footer={false}
        title="Change Password"
        visible={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form
          form={form}
          onFinish={(values) => {
            changepassword(values);
          }}
          {...formItemLayout}
        >
          <Form.Item
            label="Current Password"
            name="current_password"
            className="search-row"
            rules={[
              {
                required: true,
                message: "Please enter Current Password!",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="New Password"
            name="new_password"
            className="search-row"
            rules={[
              {
                required: true,
                message: "Please enter New Password!",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="Confirm Password"
            name="confirm_password"
            className="search-row"
            rules={[
              {
                required: true,
                message: "Please enter Confirm Password!",
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("new_password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    "The confirm passwords that you entered do not match!"
                  );
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
          <div className="profilecenter-uploadbtn">
            <Button key="back" type="primary" className='delete-btn' onClick={handleCancel}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              Change Password
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default withRouter(UserProfile);
